import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export interface NotaPessoa {
  id: number;
  conteudo: string;
  atendimentoId: number | null;
  createdAt: string;
  autor?: { nome?: string | null; name?: string | null } | null;
  autorNome?: string | null;
  criadoPor?: { nome?: string | null; sobrenome?: string | null } | null;
}

export interface AtendimentoContexto {
  atendimento: {
    id: number;
    modo: string | null;
    prioridade: string | null;
    intencaoAtual: string | null;
    fluxoAtual: string | null;
    etapaAtual: string | null;
    contexto: string | null;
  };
  customer: {
    identidade: { nomePreferencial: string | null; origem: string | null } | null;
    resumo: {
      temUsuario: boolean;
      temLead: boolean;
      quantidadePropriedades: number;
      temAnuncioAtivo: boolean;
      temPeriodoAtivo: boolean;
      temAssinaturaAtiva: boolean;
      temSolicitacaoReservaAberta: boolean;
    };
  };
}

function getAuthorization() {
  const token = validateToken();

  if (!token) {
    throw new Error("Sessão expirada. Entre novamente para consultar os atendimentos.");
  }

  return { Authorization: token.AuthStr };
}

export async function buscarNotasPessoa(atendimentoPessoaId: number) {
  const response = await axios.get<NotaPessoa[]>(
    `${Globais.DOMINIOBACK}/atendimento/pessoa/${atendimentoPessoaId}/notas`,
    { headers: getAuthorization() }
  );

  return response.data;
}

export async function buscarContextoAtendimento(atendimentoId: number) {
  const response = await axios.get<AtendimentoContexto>(
    `${Globais.DOMINIOBACK}/atendimento/${atendimentoId}/contexto`,
    { headers: getAuthorization() }
  );

  return response.data;
}

export async function criarNotaPessoa(
  pessoaId: number,
  conteudo: string,
  atendimentoId?: number
) {
  const response = await axios.post<NotaPessoa>(
    `${Globais.DOMINIOBACK}/atendimento/pessoa/${pessoaId}/notas`,
    { conteudo, ...(atendimentoId !== undefined ? { atendimentoId } : {}) },
    { headers: getAuthorization() }
  );

  return response.data;
}

export async function finalizarEArquivarAtendimento(atendimentoId: number) {
  await axios.post(
    `${Globais.DOMINIOBACK}/atendimento/${atendimentoId}/finalizar-e-arquivar`,
    { motivo: "Fornecedor" },
    { headers: getAuthorization() }
  );
}
